module.exports = __webpack_public_path__ + "sq8-6698356f.png";